import { Route } from '@angular/router';

export const objectManagementRoutes: Route[] = [
  {
    path: '',
    redirectTo: '/settings/parkings',
    pathMatch: 'full',
  },
  {
    path: 'schema',
    redirectTo: '/settings/schema',
    pathMatch: 'full',
  },
  {
    path: 'parkings',
    redirectTo: '/settings/parkings',
    pathMatch: 'full',
  },
  {
    path: 'parkings/create',
    redirectTo: '/settings/parkings/create',
    pathMatch: 'full',
  },
  {
    path: 'parkings/:id',
    redirectTo: '/settings/parkings/:id',
    pathMatch: 'full',
  },
  {
    path: 'gates',
    redirectTo: '/settings/gates',
    pathMatch: 'full',
  },
  {
    path: 'gates/create',
    redirectTo: '/settings/gates/create',
    pathMatch: 'full',
  },
  {
    path: 'gates/:id',
    redirectTo: '/settings/gates/:id',
    pathMatch: 'full',
  },
  {
    path: 'posts',
    redirectTo: '/settings/posts',
    pathMatch: 'full',
  },
  {
    path: 'posts/create',
    redirectTo: '/settings/posts/create',
    pathMatch: 'full',
  },
  {
    path: 'posts/:id',
    redirectTo: '/settings/posts/:id',
    pathMatch: 'full',
  },
  {
    path: 'devices',
    redirectTo: '/settings/devices',
    pathMatch: 'full',
  },
  {
    path: 'devices/create',
    redirectTo: '/settings/devices/create',
    pathMatch: 'full',
  },
  {
    path: 'devices/:id',
    redirectTo: '/settings/devices/:id',
    pathMatch: 'full',
  },
  {
    path: 'cameras',
    redirectTo: '/settings/cameras',
    pathMatch: 'full',
  },
  {
    path: 'cameras/create',
    redirectTo: '/settings/cameras/create',
    pathMatch: 'full',
  },
  {
    path: 'cameras/:id',
    redirectTo: '/settings/cameras/:id',
    pathMatch: 'full',
  },
];
